<template>
  <div
    :id="`${source}_action_banner`"
    class="flex flex-row action_banner w-full justify-between items-center gap-6 transition duration-400 ease-in-out"
    :style="{ background: getBannerBGColor }"
  >
    <slot></slot>

    <a-tooltip
      v-if="showCrossIcon"
      placement="bottomRight"
      color="var(--tooltip-bg)"
    >
      <template v-slot:title>
        <span class="text-[13px] text_color">Hide Navbar</span>
      </template>

      <div
        class="flex items-center justify-center cursor-pointer banner_cross rounded-lg size-6"
      >
        <ThemeImage
          class="size-6"
          :icon="imageNames.BANNER_CROSS"
          alt="banner_cross_icon"
          @click="$emit('crossClick')"
        />
      </div>
    </a-tooltip>
  </div>
</template>

<script setup>
import { computed } from "vue";
import store from "@/src/store/index.js";
import {
  bannerStatusesForGreen,
  bannerStatusesForPurple,
} from "@/src/constants/bannerConstants.js";
import {imageNames} from "@/src/constants/imageConstants.js";

const props = defineProps({
  source: { type: String, required: true },
});

const emits = defineEmits(["crossClick"]);

const bannerStatus = computed(
  () => store.getters["dynamicBanner/getBannerStatus"],
);

const getBannerBGColor = computed(() => {
  if (bannerStatusesForPurple.includes(bannerStatus.value)) {
    return "var(--action-banner-progress)";
  } else if (bannerStatusesForGreen.includes(bannerStatus.value)) {
    return "var(--action-banner-complete)";
  }
  return "var(--action-banner-progress)";
});

const showCrossIcon = computed(
  () => !store.getters["callsCampaign/isCampaignPageOpen"],
);
</script>

<style scoped>
.action_banner {
  padding: 12px 16px;
  height: 64px;
  border-radius: 8px 0 0 0;
}

.banner_cross:hover {
  transition: background-color 0.4s ease-in-out;
  background-color: var(--white-opacity-8);
}
</style>
